var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_13699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03831 6.10406C4.55607 5.62182 4.28516 4.96777 4.28516 4.28578C4.28516 3.6038 4.55607 2.94975 5.03831 2.46751C5.52055 1.98527 6.1746 1.71436 6.85658 1.71436C7.53857 1.71436 8.19262 1.98527 8.67486 2.46751C9.1571 2.94975 9.42801 3.6038 9.42801 4.28578C9.42801 4.96777 9.1571 5.62182 8.67486 6.10406C8.19262 6.5863 7.53857 6.85721 6.85658 6.85721C6.1746 6.85721 5.52055 6.5863 5.03831 6.10406Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71484 14.5713C1.71484 11.731 4.01739 9.42847 6.8577 9.42847",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2874 14.5713C22.2874 11.731 19.9849 9.42847 17.1445 9.42847",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3235 6.10406C14.8412 5.62182 14.5703 4.96777 14.5703 4.28578C14.5703 3.6038 14.8412 2.94975 15.3235 2.46751C15.8057 1.98527 16.4598 1.71436 17.1417 1.71436C17.8237 1.71436 18.4778 1.98527 18.96 2.46751C19.4423 2.94975 19.7132 3.6038 19.7132 4.28578C19.7132 4.96777 19.4423 5.62182 18.96 6.10406C18.4778 6.5863 17.8237 6.85721 17.1417 6.85721C16.4598 6.85721 15.8057 6.5863 15.3235 6.10406Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1451 22.2857C17.1451 19.4453 14.8425 17.1428 12.0022 17.1428C9.16192 17.1428 6.85938 19.4453 6.85938 22.2857",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62543 12.9839C9.4962 12.672 9.42969 12.3376 9.42969 11.9999C9.42969 11.6622 9.4962 11.3278 9.62543 11.0159C9.75465 10.7039 9.94406 10.4204 10.1828 10.1816C10.4216 9.94284 10.7051 9.75343 11.0171 9.6242C11.3291 9.49498 11.6634 9.42847 12.0011 9.42847C12.3388 9.42847 12.6732 9.49498 12.9852 9.6242C13.2971 9.75343 13.5806 9.94284 13.8194 10.1816C14.0582 10.4204 14.2476 10.7039 14.3768 11.0159C14.506 11.3278 14.5725 11.6622 14.5725 11.9999C14.5725 12.3376 14.506 12.672 14.3768 12.9839C14.2476 13.2959 14.0582 13.5794 13.8194 13.8182C13.5806 14.0569 13.2971 14.2464 12.9852 14.3756C12.6732 14.5048 12.3388 14.5713 12.0011 14.5713C11.6634 14.5713 11.3291 14.5048 11.0171 14.3756C10.7051 14.2464 10.4216 14.0569 10.1828 13.8182C9.94406 13.5794 9.75465 13.2959 9.62543 12.9839Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_13699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleManagement);
export default __webpack_public_path__ + "static/media/people_management.fb6d7db0b2c438227cb380ad892ce582.svg";
export { ForwardRef as ReactComponent };